import 'jquery-validation';
import {showButtonLoader, hideButtonLoader} from '../util/helpers';

export default {
  init: function () {

    var forgotPasswordForm = $('#forgotPasswordForm');
    var submitButton = $('#wp-submit');

    submitButton.on('click', function (e) {
      e.preventDefault();
      showButtonLoader(submitButton);
      
      setTimeout(() => {
        var valid = forgotPasswordForm.valid();
        if (valid) {
          setTimeout(function () {
            forgotPasswordForm.submit();
          }, 1000);
        }else {
          hideButtonLoader(submitButton);
          $('#inputEmail-error').hide();
        }
      }, 1000);
    });

  },
};



// WEBPACK FOOTER //
// ./scripts/routes/forgotpassword.js